const state = {
  company: {},
  isActive: false,
  settings: [],
  settingsLoading: false,
  settingsError: null,
};

export default state;
